import { SaveButton } from "components/Buttons"
import { Row, Col } from "reactstrap"

const BottomNavigation = ({
  handleBack,
  handleNext,
  handleSave,
  saveButtonDisabled,
  loading,
}) => {
  return (
    <Row className="my-3">
      <Col className="my-1">
        {handleBack && (
          <SaveButton type="button" onClick={handleBack}>
            Back
          </SaveButton>
        )}
      </Col>
      <Col xs="auto" className="my-1">
        {handleSave && (
          <SaveButton
            type="button"
            onClick={handleSave}
            disabled={saveButtonDisabled}
            loading={loading}
          >
            Save
          </SaveButton>
        )}
      </Col>
      {handleNext && (
        <Col xs="auto" className="my-1">
          <SaveButton type="button" onClick={handleNext}>
            Next
          </SaveButton>
        </Col>
      )}
    </Row>
  )
}

export default BottomNavigation
